$('[data-js-expand-toggle]').on 'click', ->
  $collapsableList = $(this).next('ul')
  $(this).toggleClass('is-expanded')
  $collapsableList.toggleClass('is-collapsed')
  window.parent.postMessage("cliniko-bookings-resize:#{document.body.offsetHeight}", '*')

  tabindex = if $(this).hasClass('is-expanded') then 0 else -1
  $collapsableList.find('button').attr('tabindex', tabindex)
  $collapsableList.attr('aria-expanded', tabindex == 0)
